import { useState, useEffect } from 'react'
import { DebounceInput } from 'react-debounce-input'
import {
  saveInquiry,
  getMessageTemplate,
  isValidMessage,
} from 'lib/services/inquiry'
import { fromUnix, toUnix } from 'lib/utils/dates'
import { updateSuccessMessage } from 'lib/utils/success-message'
import Image from 'components/Image'
import Link from 'components/Navigation/WrapperLink'
import ExternalLink from 'components/ExternalLink'
import Select from 'components/AddInquiry/Select'
import DatePicker from 'components/AddInquiry/DatePicker'
import Number from 'components/AddInquiry/Number'
import Attention from './Attention'
import selectStyles from './styles/select'
import styles from './CartItem.module.scss'

export default function CartItem({ item, removeItem }) {
  const {
    id,
    name,
    slug,
    location: initialLocation,
    eventType: initialCategory,
    dateTime: initialDateTime,
    guests: initialGuests,
    locations,
    categories,
    image,
    map_link: mapLink,
    message: initialMessage,
  } = item
  const [location, setLocation] = useState(initialLocation)
  const [category, setCategory] = useState(initialCategory)
  const [dateTime, setDateTime] = useState(fromUnix(initialDateTime))
  const [guests, setGuests] = useState(initialGuests)
  const [message, setMessage] = useState(initialMessage)
  const [successMessage, setSuccessMessage] = useState('')
  const [isFlexible, setIsFlexible] = useState(false)

  const maybeAddDefaultMessage = (value) => {
    if (!value || value === '') {
      setMessage(getMessageTemplate())
    }
  }

  const handleRemove = (itm) => {
    removeItem(itm)
  }
  /**
   * When new selections are made,
   * persist them to store.
   */
  useEffect(() => {
    saveInquiry(
      id,
      location,
      category,
      toUnix(dateTime),
      guests.toString(),
      message,
      isFlexible,
    )
  }, [location, category, dateTime, guests, message, isFlexible])

  /**
   * When new message is written,
   * show UX note about saving it.
   */
  useEffect(() => {
    if (message !== initialMessage) {
      updateSuccessMessage('Viesti tallennettu👍', setSuccessMessage)
    }
  }, [message])

  return (
    <div className={styles.teaser}>
      <dl className={styles.details}>
        {location && (
          <>
            <dt className={styles.detailHeading}>Sijainti:</dt>
            <dd className={styles.detailContent}>
              <Select
                options={locations}
                active={location}
                callback={setLocation}
                style={selectStyles}
              />
            </dd>
          </>
        )}
        {category && (
          <>
            <dt className={styles.detailHeading}>Tapahtuma:</dt>
            <dd className={styles.detailContent}>
              <Select
                options={categories}
                active={category}
                callback={setCategory}
                style={selectStyles}
              />
            </dd>
          </>
        )}
        <dt className={styles.detailHeading}>Päivämäärä:</dt>
        <dd className={styles.detailContent}>
          <DatePicker
            date={dateTime}
            callback={setDateTime}
            extraClasses="small-datepicker"
          />
        </dd>
        <dt className={styles.detailHeading}>Henkilömäärä:</dt>
        <dd className={styles.detailContent}>
          <Number active={guests} callback={setGuests} />
        </dd>
      </dl>
      <dl className={styles.details}>
        <dt className={styles.flexibleHeading}>Joustava Aika:</dt>
        <dd className={styles.flexibleContent}>
          <input
            id="isFlexible"
            name="isFlexible"
            type="checkbox"
            className={styles.checkbox}
            checked={isFlexible}
            onChange={(ev) => {
              setIsFlexible(ev.target.checked)
            }}
          />
        </dd>
      </dl>
      {(!guests || guests < 1) && (
        <div className={styles.guestError}>
          <Attention message="Tarkennathan henkilömäärän" />
        </div>
      )}
      <div className={styles.wrap}>
        <div className={styles.imageWrap}>
          <div className={styles.imageFrame}>
            <Link data={{ slug, type: 'eventWithSlash' }}>
              {image && (
                <Image image={image} size="teaser-retina" layout="responsive" />
              )}
            </Link>
          </div>
        </div>
        <div className={styles.contentWrap}>
          <h5 className={styles.title}>
            <Link data={{ slug, type: 'eventWithSlash' }}>{name}</Link>
          </h5>
          {mapLink && (
            <ExternalLink
              title="Katso kartalla"
              href={mapLink}
              classes={styles.link}
            />
          )}
        </div>
        <div className={styles.messageWrap}>
          <label>
            Viesti
            <abbr title="Pakollinen kenttä" className={styles.required}>
              *
            </abbr>
            <DebounceInput
              element="textarea"
              className={styles.message}
              debounceTimeout={800}
              autoComplete="off"
              onChange={(event) => setMessage(event.target.value)}
              value={message}
              placeholder={getMessageTemplate()}
              onClick={(e) => maybeAddDefaultMessage(e.target.value)}
            />
          </label>
          {!isValidMessage(message) && (
            <div>
              <Attention message="Huom! Täytä viesti, jotta voit edetä" />
            </div>
          )}
          {successMessage && isValidMessage(message) && (
            <span className={styles.successMessage}>{successMessage}</span>
          )}
        </div>
        <div className={styles.removeWrap}>
          <span
            role="button"
            onClick={() => handleRemove(item)}
            className={styles.remove}
          >
            Poista
          </span>
        </div>
      </div>
    </div>
  )
}
